import { useState, useMemo } from 'react';
import ViewHours from '../components/ViewHours';
import ViewTimeOff from '../components/ViewTimeOff';
import AddTimeOff from '../components/AddTimeOff';

export const useTabs = ({ fullAccess, timeclock, availabilityEnabled, canRequestTimeOff }) => {
  const tabs = useMemo(
    () => [
      ...(fullAccess && timeclock ? [{ title: 'View Hours', Component: ViewHours }] : []),
      ...(availabilityEnabled ? [{ title: 'View Time Off', Component: ViewTimeOff }] : []),
      ...(availabilityEnabled && canRequestTimeOff
        ? [{ title: 'Add Time Off', Component: AddTimeOff }]
        : []),
    ],
    [fullAccess, timeclock, availabilityEnabled, canRequestTimeOff]
  );

  const [currentTab, setCurrentTab] = useState(0);

  return {
    tabs,
    currentTab,
    setCurrentTab,
  };
};
